import { Flag } from "./Flag";
import { FtblCoverImageBlock, FtblCoverImageInfo, FtblCoverImageName, FtblCoverImageScore } from "./styles";

interface TeamWithScoreProps {
    name?: string;
    score?: number | null;
    flagCountryId?: number;
    isReverse?: boolean;
}

export const TeamWithScore = ({ name, score, flagCountryId, isReverse }: TeamWithScoreProps) => (
    <FtblCoverImageBlock isReverse={isReverse}>
        <Flag countryId={flagCountryId} />
        <FtblCoverImageInfo>
            <FtblCoverImageName>{name}</FtblCoverImageName>
            <FtblCoverImageScore>{score}</FtblCoverImageScore>
        </FtblCoverImageInfo>
    </FtblCoverImageBlock>
)
import { Flag } from "./Flag";
import { FtblCoverImageBlock, FtblCoverImageInfo, FtblCoverImageName, FtblCoverImageScore } from "./styles";

interface TeamWithScoreProps {
    name?: string;
    score?: number | null;
    flagCountryId?: number;
    isReverse?: boolean;
}

export const TeamWithScore = ({ name, score, flagCountryId, isReverse }: TeamWithScoreProps) => (
    <FtblCoverImageBlock isReverse={isReverse}>
        <Flag countryId={flagCountryId} />
        <FtblCoverImageInfo>
            <FtblCoverImageName>{name}</FtblCoverImageName>
            <FtblCoverImageScore>{score}</FtblCoverImageScore>
        </FtblCoverImageInfo>
    </FtblCoverImageBlock>
)
